class DragObject {
    constructor() {}
    getPosition() { throw new Error('not implemented'); }
    setPosition({ x, y }) { throw new Error('not implemented'); }
    getSize() { throw new Error('not implemented'); }
    setSize({ x, y }) { throw new Error('not implemented'); }
}

export default DragObject;
